// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoEmbed_container__of_vW","placeholder":"VideoEmbed_placeholder__0oL5v","thumbnail":"VideoEmbed_thumbnail__U7Hu2","iframe":"VideoEmbed_iframe__aYXrK"};